import { ErrorsType } from "..";
import { Custom } from "./Custom";

interface Props {
    tasOccurrenceNumber?: string;
    isLoading: boolean;
    subject?: string;
    customerComment: string;
    handleChangeComment: (comment: string) => void;
    diagnose: string;
    handleDiagnose: (diagnose: string) => void;
    repair: string;
    handleRepair: (repair: string) => void;
    analysisReason: string;
    handleAnalysisReason: (repair: string) => void;
    partName: string;
    handlePartName: (partName: string) => void;
    aeg: string;
    handleAeg: (aeg: string) => void;
    errors: ErrorsType;
    cancelComment: string
    handleCancelComment: (aeg: string) => void;
    vehicleQtd: string;
    handleVehicleQtd: (aeg: string) => void;
    cancelReason: string;
    handleCancelReason: (cancel: string) => void;
}

const AdditionalData = ({
    tasOccurrenceNumber,
    isLoading,
    customerComment,
    handleChangeComment,
    subject,
    diagnose,
    handleDiagnose,
    repair,
    handleRepair,
    analysisReason,
    handleAnalysisReason,
    partName,
    handlePartName,
    aeg,
    handleAeg,
    errors,
    cancelComment,
    handleCancelComment,
    handleVehicleQtd,
    vehicleQtd,
    cancelReason,
    handleCancelReason
}: Props) => {

    const onlyNumbers = (value: string) => {
        return value.replace(/\D/g, '');
    };

    return (
        <div className="width-100pct height-100pct border rounded padding-15">
            <div className="margin-bottom-15">
                <span className="text-size-14 text-medium text-color-black">2. Dados adicionais</span>
            </div>
            <div className="width-100pct display-flex flex-row gap-20">
                {subject === 'CONTRACT_CANCELLATION'? (
                    <Custom.Input label='Número do contrato*' value={tasOccurrenceNumber} disabled={true} isLoading={isLoading} />
                ) : null}

                {subject === "CONTRACT_CANCELLATION" ? (
                    <>
                        <Custom.Input
                            label='Quantidade de veículos*'
                            value={vehicleQtd}
                            isLoading={isLoading}
                            onChange={handleVehicleQtd}
                            error={errors.vehicleQtd}
                            placeholder="Obrigatório"
                            disabled
                        />

                        <Custom.Input
                            label='Motivo do cancelamento*'
                            value={cancelReason}
                            isLoading={isLoading}
                            onChange={handleCancelReason}
                            error={errors.cancelReason}
                            placeholder="Obrigatório"
                            disabled
                        />
                    </>
                ) : null}

                {subject === "TECHNICAL" ? (
                    <>
                        <Custom.Input
                            label='Nome da peça causadora*'
                            value={partName}
                            isLoading={isLoading}
                            onChange={handlePartName}
                            error={errors.partName}
                            placeholder="Obrigatório"
                            disabled
                        />
                        <Custom.Input
                            label='Nº AEG'
                            value={aeg}
                            isLoading={isLoading}
                            onChange={(e) => handleAeg(onlyNumbers(e))}
                            error={errors.aeg}
                            placeholder="Opcional"
                            // disabled
                        />
                    </>
                ) : null}
            </div>


            {subject === 'CONTRACT_CANCELLATION' ? (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={'Descrever a solicitação*'}
                        value={cancelComment} 
                        onChange={handleCancelComment}
                        isLoading={isLoading}
                        error={errors.cancelComment}
                        placeholder="Obrigatório"
                        disabled
                    />
                </div>
            ) : (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={subject === "TECHNICAL" ? "Qual a reclamação do cliente?*" : "Detalhe da solicitação"}
                        value={customerComment} 
                        onChange={handleChangeComment}
                        isLoading={isLoading}
                        error={errors.customerComment}
                        placeholder={subject === "TECHNICAL" ? 'Obrigatório': 'Opcional'}
                        disabled
                    />
                </div>
            )}

            {subject === "TECHNICAL" ? (
                <div className="width-100pct">
                    <Custom.TextArea
                        label="Diagnóstico / causa da falha*"
                        value={diagnose}
                        onChange={handleDiagnose}
                        isLoading={isLoading}
                        error={errors.diagnose}
                        placeholder="Obrigatório"
                        disabled
                    />
                    <Custom.TextArea
                        label="Reparo necessário*"
                        value={repair}
                        onChange={handleRepair}
                        isLoading={isLoading}
                        error={errors.repair}
                        placeholder='Obrigatório'
                        disabled
                    />
                    <Custom.TextArea
                        label="Motivo do envio para análise*"
                        value={analysisReason}
                        onChange={handleAnalysisReason}
                        isLoading={isLoading}
                        error={errors.analysisReason}
                        placeholder="Obrigatório"
                        disabled
                    />
                </div>
            ) : null}
        </div>
    )
}

export default AdditionalData;